/**
 * 静态资源地址解析
 * ============================================================
 *
 * 为什么需要这个文件：
 *
 * 应用现在要能部署在**子目录**下（例如 `https://xxx.tcloudbaseapp.com/dialectgo/`），
 * 而老师的立绘、386 条口型片段、图标都是静态资源。它们的路径原本写成
 * 绝对形式 `/teachers/...` —— 这种写法在站点根目录部署时没问题，
 * 一旦放到子目录就全部指向域名根，**404 且不报错**（拿到 HTML 后
 * video 元素只会说"格式不支持"，与真正的原因差得很远）。
 *
 * Vite 的 `base` 只会自动改写它自己处理过的引用（index.html 里的
 * script/link、import 的资源），**不会**改写 JS 里手写的字符串，
 * 也不会改写 JSON 里存的路径。所以必须显式过一遍这个函数。
 *
 * 用法约定：
 *   · 以 `http(s)://` 或 `data:` 开头 —— 视为完整地址，原样返回
 *     （云端 CDN、外链图片不应该被加前缀）
 *   · 其余一律当作「站点内的路径」，按当前 base 补前缀
 *   · 传入 null/空串 —— 原样返回，让调用方自己处理缺省
 */

/** Vite 注入的 base，形如 `/` 或 `/dialectgo/`（一定以 / 结尾） */
const BASE = import.meta.env?.BASE_URL || '/';

/** 去掉结尾斜杠后的 base，用于拼接（根路径时为空串） */
const BASE_NO_TAIL = BASE.replace(/\/+$/, '');

/**
 * @param {string|null|undefined} p 站点内路径，如 `/teachers/aqing/portrait.png`
 * @returns {string|null|undefined}
 */
export function assetUrl(p) {
  if (!p) return p;
  const s = String(p);
  if (/^(https?:)?\/\//i.test(s) || s.startsWith('data:') || s.startsWith('blob:')) {
    return s;
  }
  const clean = s.replace(/^\/+/, '');
  return `${BASE_NO_TAIL}/${clean}`;
}

/**
 * 站点内某个路径的完整 URL（用于分享、跳转）
 * @param {string} p
 */
export function siteUrl(p = '/') {
  const clean = String(p).replace(/^\/+/, '');
  return `${window.location.origin}${BASE_NO_TAIL}/${clean}`;
}

/** 当前 base（去掉结尾斜杠），交给 react-router 的 basename */
export const ROUTER_BASE = BASE_NO_TAIL || '/';
